const DEFAULT_COOKIE_URLS = {
	ca_ES: 'https://webpublication.es/cookies',
	de_DE: 'https://webpublication.co.uk/cookies',
	en_UK: 'https://webpublication.co.uk/cookies',
	es_ES: 'https://webpublication.es/cookies',
	fr_FR: 'https://webpublication.fr/cookies',
	it_IT: 'https://webpublication.co.uk/cookies',
	pt_PT: 'https://webpublication.co.uk/cookies',
};

export { DEFAULT_COOKIE_URLS };


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/CookieNotification/constants.ts